/**
 * Cart Drawer Handler
 * Intercepts cart navigation and opens drawer instead
 */
class CartDrawerHandler {
  constructor() {
    this.init();
  }

  init() {
    this.handleHash();
    this.interceptCartLinks();
    window.addEventListener('hashchange', () => this.handleHash());
  }

  getDrawerName() {
    // Check which drawer variant is active
    const mCartDrawer = document.querySelector('.m-cart-drawer');
    if (mCartDrawer) {
      return 'm-cart-drawer';
    }
    return 'cart-drawer';
  }

  handleHash() {
    if (window.location.hash === '#open-drawer') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      
      requestAnimationFrame(() => {
        const drawerName = this.getDrawerName();
        document.dispatchEvent(new CustomEvent(`dialog:trigger:${drawerName}`));
      });
    }
  }

  interceptCartLinks() {
    document.addEventListener('click', (e) => {
      const link = e.target.closest('a[href*="/cart"]');
      if (!link) return;

      const href = link.getAttribute('href') || '';
      // Don't intercept auth/login links that use return_url=/cart (e.g. Love Loyalty, Customer Accounts)
      if (href.includes('customer_authentication') || href.includes('/account/login')) return;

      const isCartLink = href === '/cart' || 
                        href.endsWith('/cart') ||
                        (window.routes && (href === window.routes.cart_url || href.endsWith(window.routes.cart_url)));

      if (isCartLink && !link.closest('dialog-trigger[data-name="cart-drawer"]') && !link.closest('dialog-trigger[data-name="m-cart-drawer"]')) {
        e.preventDefault();
        const drawerName = this.getDrawerName();
        document.dispatchEvent(new CustomEvent(`dialog:trigger:${drawerName}`));
      }
    }, true);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CartDrawerHandler());
} else {
  new CartDrawerHandler();
}
